import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import React from "react";

export default function SummaryInvoice({
  popUpOpen,
  setPopUpOpen,
  popUpData,
  summaryTrigger,
  setSummaryTrigger,
}) {
  console.log("popUpData......popUpData", popUpData);
  const dropDownData = ["TAX INVOICE", "PAYMENT RECEIPT"];
  const [InvoiceSent, setInvoiceSent] = useState();
  const [loading, setLoading] = useState(false);
  const [filetype, setFiletype] = useState();

  const handleFileTypeChange = (value) => {
    setFiletype(value);
  };
 
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  const hanldeClose = () => {
    setPopUpOpen(false);
  };
  const token = localStorage.getItem("nodeToken");
  const submitHandler = async (e, fileData) => {
    e.preventDefault();
    for (let file of files) {
      let type = file.name.split(".").pop();
      if (type !== "pdf") {
        dispatch(setAppError({ msg: "All files should be in PDF format" }));
        setLoading(false);
        return;
      }
    }

    try {
      const formData = new FormData();
      // formData.append("file", files);
      files.forEach((file) => {
        formData.append("file", file); // Ensure the field name is 'file'
      });
      formData.append("invoiceNumber", popUpData?.invoice_no);
      formData.append("invoice_sent_date", InvoiceSent);
      formData.append("Upload_invoice_type", filetype);
      const response = await nodeinstance.put(
        `/dashboard/visaSecOnArrival/updateInvoice`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        setPopUpOpen(false);
        dispatch(
          setAppError({
            msg: "Invoice uploaded successfully..",
            color: "success",
          })
        );
        setSummaryTrigger(!summaryTrigger);
      }
    } catch (error) {
      console.log("error to be displayed here...", error);
      setPopUpOpen(true);
      setLoading(false);
      dispatch(
        setAppError({
          msg: "Failed to update the invoice amount....",
        })
      );
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          popUpOpen ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <form onSubmit={(e) => submitHandler(e, files)} className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  INVOICE SENT DATE
                </label>
                <input
                  type="Date"
                  value={InvoiceSent}
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  onChange={(e) => {
                    setInvoiceSent(e.target.value);
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                  required
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  INVOICE NO
                </label>
                <input
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  value={popUpData?.invoice_no}
                  disabled
                />
              </div>
              <div className="flex flex-col gap-1 w-full max-w-md mt-2">
                <label htmlFor={`addOrEdit-name`} style={{ fontSize: "10px" }}>
                  CHOOSE FILE TYPE
                </label>
                <select
                  // {...register("visaprovider")}
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-4 text-md"
                  onChange={(e) => {
                    handleFileTypeChange(e.target.value);
                  }}
                >
                  <option>{"select value"}</option>
                  {dropDownData?.map((data, index) => (
                    <React.Fragment key={index}>
                      <option value={data}>{data}</option>
                    </React.Fragment>
                  ))}
                </select>
              </div>

              <div className="form-control w-full ">
                <label className="label">
                  <span className="label-text">Upload File</span>
                </label>
                <input
                  type="file"
                  className="file-input file-input-bordered w-full"
                  onChange={handleFileChange}
                  required
                  accept="application/pdf"
                  multiple
                />
              </div>
              <div
                className="flex gap-3 w-full justify-center"
                style={{ m: 2 }}
              >
                <button
                  className="p-2 bg-blue text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                  onClick={() => {
                    hanldeClose();
                  }}
                >
                  {" "}
                  <p>CANCEL</p>
                </button>
                <button
                  type="submit"
                  className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                >
                  {" "}
                  <p>Submit</p>
                  {loading ? <CgSpinner className="animate-spin" /> : ""}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
